import type { WireActivityItem } from '@logistics/contracts';

export type ActivityType = WireActivityItem['type'];

/** The filter bar (design L438–442): a label, and the `type` it asks the API for. */
export const FILTERS: readonly { readonly label: string; readonly type?: ActivityType }[] = [
  { label: 'All' },
  { label: 'Replies', type: 'reply' },
  { label: 'Retrievals', type: 'retrieve' },
  { label: 'Blocked', type: 'blocked' },
  { label: 'Errors', type: 'error' },
];

export function isActivityType(value: string | undefined): value is ActivityType {
  return FILTERS.some((f) => f.type !== undefined && f.type === value);
}

/** REPLY, RETRIEVE, BLOCKED, ERROR — and the colour each is set in. */
export function typeLook(type: ActivityType): { label: string; color: string } {
  switch (type) {
    case 'reply':
      return { label: 'REPLY', color: 'var(--acc)' };
    case 'retrieve':
      return { label: 'RETRIEVE', color: 'var(--mute)' };
    case 'blocked':
      return { label: 'BLOCKED', color: 'var(--warn)' };
    case 'error':
      return { label: 'ERROR', color: 'var(--bad)' };
  }
}
